import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import { Icon } from '../';
export const Button = forwardRef(({ children, color, preIcon, postIcon, className, dataTestId, style, size, fullWidthOnMobile = false, preIconClassName, isLoading, disabled, clickableDuringLoading = false, ...restProps }, ref) => {
    const buttonClassName = classNames('flex items-center gap-1 font-bold disabled:ring-0 transition-all duration-400 relative', fullWidthOnMobile ? 'justify-center w-full md:w-fit' : 'w-fit', {
        'text-mBase md:text-base py-[13px] md:py-[9px]': !size,
        'text-sm py-[7.5px]': size === 'sm',
        'text-base py-[9px]': size === 'md',
        'text-mBase py-[13px]': size === 'lg'
    }, style === 'pill'
        ? 'rounded-full'
        : {
            'rounded-2xl md:rounded-xl': !size,
            'rounded-lg': size === 'sm',
            'rounded-xl': size === 'md',
            'rounded-2xl': size === 'lg'
        }, { 'disabled:cursor-not-allowed disabled:opacity-30': !isLoading }, style === 'text-only'
        ? 'px-2 disabled:text-gray-400'
        : !isLoading && 'disabled:text-gray disabled:bg-gray-200', style === 'text-only'
        ? {
            'text-primary hover:bg-secondary-100 active:text-primary-600': color === 'blue',
            'text-secondary hover:bg-secondary-100 active:text-secondary-600': color === 'green',
            'text-red hover:bg-red-100 active:bg-red active:text-white': color === 'red',
            'text-gray-700 hover:bg-gray-50 active:text-black': color === 'white'
        }
        : {
            'bg-primary text-white hover:bg-primary-600': color === 'blue',
            'bg-secondary-100 text-primary hover:text-primary-600': color === 'blue-alt',
            'bg-secondary text-white hover:bg-secondary-600': color === 'green',
            'bg-secondary-100 text-secondary hover:bg-secondary-200': color === 'green-alt',
            'bg-red text-white hover:bg-red-600': color === 'red',
            'bg-red-100 text-red hover:bg-red hover:text-white': color === 'red-alt',
            'bg-white text-gray-700 ring-1 ring-gray-200 hover:ring-gray-400 active:text-black': color === 'white',
            'bg-gray-800/5 text-gray-700 hover:text-black': color === 'white-alt',
            'px-6 md:px-5': !size,
            'px-4': size === 'sm',
            'px-5': size === 'md',
            'px-6': size === 'lg'
        }, className);
    const iconClassName = classNames('flex-none', size ? (size === 'lg' ? 'w-5 h-5' : 'w-4 h-4') : 'w-4 h-4', {
        'opacity-0': isLoading
    });
    return (_jsxs("button", { className: buttonClassName, "data-testid": dataTestId, disabled: disabled || (isLoading && !clickableDuringLoading), ...restProps, ref: ref, children: [preIcon && _jsx(Icon, { className: classNames(iconClassName, preIconClassName), name: preIcon }), isLoading ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "text-transparent", children: children }), _jsx(Icon, { className: classNames('animate-spin absolute inset-x-0 mx-auto', {
                            'w-4 h-4': size === 'sm'
                        }), name: "loader" })] })) : (children), postIcon && _jsx(Icon, { className: iconClassName, name: postIcon })] }));
});
Button.displayName = 'Button';
